import { render } from "./ContentTableSwitch.vue?vue&type=template&id=05928ec6"
import script from "./ContentTableSwitch.vue?vue&type=script&lang=js"
export * from "./ContentTableSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__